import React, { PureComponent } from 'react';
import { getTalkTime } from '../../utils/utils';
import { getTalkTimeEn } from '../../utils/utils';

class LoadingBalloon extends PureComponent {
	render() {
		let inStyle = {
			width : "60px",
			paddingTop : "5px",
			minWidth : "60px"
		}
		return (
			<div className="bot_wrap">
				<span className="ico_comm ico_chatbot"></span>
				<span className="bot_name">{this.props.uiTexts.text_00}</span>
				<div className="bot_box">
					<div className="bot_txt" style={inStyle}>
						<div className="three-balls">
							<div className="ball ball1"></div>
							<div className="ball ball2"></div>
							<div className="ball ball3"></div>
						</div>
					</div>
				</div>
				<span className="time slide">{this.props.lang != 'en' ? getTalkTime() : getTalkTimeEn() }</span>
			</div>
		);
	}
}

export default LoadingBalloon;
